/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ConfirmForgotLicensingPasswordError = "CODEEXPIRED" | "CODEMISMATCH" | "INVALIDINPUT" | "PASSWORDINVALID" | "UNKNOWNERROR" | "USERNOTCONFIRMED" | "%future added value";
export type ConfirmForgotLicensingPasswordInput = {
    code?: string | null | undefined;
    email?: string | null | undefined;
    newPassword?: string | null | undefined;
};
export type confirmForgotPasswordMutationVariables = {
    input: ConfirmForgotLicensingPasswordInput;
};
export type confirmForgotPasswordMutationResponse = {
    readonly confirmForgotLicensingPassword: {
        readonly wasSuccessful: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: ConfirmForgotLicensingPasswordError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type confirmForgotPasswordMutation = {
    readonly response: confirmForgotPasswordMutationResponse;
    readonly variables: confirmForgotPasswordMutationVariables;
};



/*
mutation confirmForgotPasswordMutation(
  $input: ConfirmForgotLicensingPasswordInput!
) {
  confirmForgotLicensingPassword(input: $input) {
    wasSuccessful
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfirmForgotLicensingPassword",
            "kind": "LinkedField",
            "name": "confirmForgotLicensingPassword",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfConfirmForgotLicensingPassword",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "confirmForgotPasswordMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "confirmForgotPasswordMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "04ef6971a7bb0790c2709154d245226e",
            "id": null,
            "metadata": {},
            "name": "confirmForgotPasswordMutation",
            "operationKind": "mutation",
            "text": "mutation confirmForgotPasswordMutation(\n  $input: ConfirmForgotLicensingPasswordInput!\n) {\n  confirmForgotLicensingPassword(input: $input) {\n    wasSuccessful\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '627c859f74c3c86f0d4f538c639da660';
export default node;
